import Layout from "../components/Layout";
import { NoteList } from "../components/Entries";
import { notes } from "../content/writing";
import styles from "../styles/Site.module.css";

const Notes = () => {
    return (
        <Layout>
            <h1 className={styles.pageTitle}>Blog</h1>
            <p className={styles.intro}>
                Old notes, with new ones on the way.
            </p>
            <NoteList items={notes} />
        </Layout>
    );
};

export default Notes;
